/**
 * Brand Management API Requests
 * Handles all API calls related to brand configuration
 */

import axios, { AxiosResponse } from 'axios'
import { BrandConfig, BrandConfigResponse } from './_models'
import { EmpresaView } from 'app/modules/apps/empresa/empresas-list/core/_models'

const API_URL = process.env.REACT_APP_API_URL

const EMPRESA_URL = `${API_URL}/empresas`
export const BRAND_CONFIG_URL = `${API_URL}/empresas/token`

/**
 * Fetch complete brand configuration from the backend.
 * The backend resolves the company/layout from the authenticated session.
 * @returns Promise with full brand config, or `null` when the company has none
 * @throws on network/server failure — callers must tell "no brand" apart from "failed to load"
 */
export const fetchBrandConfig = async (): Promise<BrandConfigResponse | null> => {
  const response: AxiosResponse<BrandConfigResponse> = await axios.get(`${BRAND_CONFIG_URL}`)
  return response.data || null
}

/**
 * Update brand configuration
 * Sends JSON with all brand config variables
 *
 * @param idEmpresa - ID da empresa
 * @param brandConfig - Brand configuration object with updated values
 */
export const updateBrandLayout = async (
  idEmpresa: number,
  brandConfig: BrandConfig
): Promise<BrandConfigResponse> => {
  const payload: Record<string, unknown> = {}

  if (brandConfig.primaryColor) payload.primaryColor = brandConfig.primaryColor
  if (brandConfig.asideColor) payload.asideColor = brandConfig.asideColor
  if (brandConfig.primaryActiveColor) payload.primaryActiveColor = brandConfig.primaryActiveColor

  return await axios.patch(`${EMPRESA_URL}/${idEmpresa}/layout`, payload)
}

export const updateBrandLogo = async (
  idEmpresa: number,
  file: File
): Promise<BrandConfigResponse> => {
  const formData = new FormData()
  formData.append('file', file)

  return await axios.patch(`${EMPRESA_URL}/${idEmpresa}/logo`, formData)
}

/**
 * Altera a imagem de login da empresa
 * @param idEmpresa ID da empresa
 * @param file Imagem de login
 * @returns EmpresaView
 */
export const updateBrandImagemLateral = async (
  idEmpresa: number,
  file: File
): Promise<EmpresaView> => {
  const formData = new FormData()
  formData.append('file', file)

  return await axios.patch(`${EMPRESA_URL}/${idEmpresa}/imagem`, formData)
}
